@if (showCard()) {
<forge-card class="no-padding">
    <forge-toolbar>
        <h2 class="forge-typography--heading4">User Lookup</h2>
    </forge-toolbar>

    <div [formGroup]="userLookupForm" fxLayout="column" fxLayoutAlign="space-between stretch">
        <lgd-typeahead fxFlex controlName="user" label="User Lookup" [hideLabel]="true" [options]="userLookupObservable"
                       (searchTextChanged)="lookupUser($event)">
        </lgd-typeahead>

        @if (loading()) {
        <busy-indicator></busy-indicator>
        }

        @if(selectedUserId()) {
        <info-card [item]="userCard">
        </info-card>

        <info-card [item]="userEquipmentCard" [expand]="true" class="no-padding">
        </info-card>
        }
    </div>
</forge-card>
}
